import { render, staticRenderFns } from "./ExacerbationsBlock.vue?vue&type=template&id=00a1aa29&lang=pug&"
import script from "./ExacerbationsBlock.vue?vue&type=script&lang=js&"
export * from "./ExacerbationsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ExacerbationsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports